module.exports = __webpack_public_path__ + "static/media/badge-percent.80086d24.png";